import uniqid from 'uniqid'
import { skills } from '../../portfolio'
import './Skills.css'

const Skills = () => {
  if (!skills.length) return null

  return (
    <section className='section skills padding-top' id='skills'>
      <h2 className='section__title padding-b'>Skills.</h2>
      <p style={{textAlign: "center"}}>Here are some skills and technologies I&apos;ve been working on recenty :</p>
      <ul className='skills__list p-t'>
        {skills.map((skill) => (
          <li key={uniqid()} className='skills__list-item btn btn--plain'>
            {skill}
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Skills
